module.exports = __webpack_public_path__ + "static/media/footer-recherche.667fee5f.png";